<template>
    <div ref="list" class="tw-space-y-4">
        <div v-for="actionItem in actionItems" :key="actionItem._id" class="tw-flex tw-space-x-4">
            <div
                v-b-popover.hover.right="$t('meetings.labelMarkComplete')"
                class="tw-flex-grow-0 tw-cursor-pointer"
                tabindex="0"
                @click="() => toggleActionItemStatus(actionItem)"
                @keyup.enter="() => toggleActionItemStatus(actionItem)"
            >
                <i
                    :class="[
                        actionItem.status === 'done'
                            ? 'fas fa-check-square color-success'
                            : 'fal fa-square color-grey',
                    ]"
                />
            </div>

            <div
                class="tw-flex-1 tw-overflow-hidden tw-cursor-pointer"
                :class="{ 'tw-line-through': actionItem.status === 'done' }"
                @click="() => openActionItem(actionItem)"
                @keyup.enter="() => openActionItem(actionItem)"
            >
                <l-text class="tw-break-words" :text="actionItem.content" />

                <div class="tw-text-gray-500">
                    <template v-if="actionItem.checkin">
                        {{ actionItem.checkin.title || "Meeting" }} -
                    </template>
                    <template v-if="actionItem.survey">{{ actionItem.survey.name }} - </template>
                    {{ actionItem.created_at | moment("MMM D") }}
                </div>
            </div>
        </div>

        <l-user-profile-load-more
            :items="actionItems"
            :value.sync="maxAmountVisible"
            :max-amount-visible="6"
            :scroll-to-element="$refs.list"
        />
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LText from "@/components/LText";
import LUserProfileLoadMore from "@/components/LUserProfile/LUserProfileLoadMore";

export default {
    components: {
        LText,
        LUserProfileLoadMore,
    },
    props: {
        actionItems: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            maxAmountVisible: 5,
        };
    },
    computed: {
        ...mapGetters({
            user: "users/current/user",
        }),
    },
    methods: {
        toggleActionItemStatus(actionItem) {
            actionItem.status = actionItem.status === "done" ? "" : "done";

            this.$store.dispatch({
                type: "meetings/meetings/updateActionItem",
                payload: { data: { ...actionItem }, meetingId: actionItem?.checkin?._id },
            });
        },
        openActionItem(actionItem) {
            if (actionItem.type === "checkinActionItem") {
                this.$router.push(`/meetings/details/${actionItem.checkin._id}`);
            } else {
                this.$router.push(
                    `/surveys/insights/${actionItem.survey._id}/action_items?actionItemId=${actionItem._id}`,
                );
            }
        },
    },
};
</script>
